"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var Icon = function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "M5.953 5.403a2.25 2.25 0 0 1 2.25-2.25 2.25 2.25 0 1 1-2.25 2.25zM2.25 11.99a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "M6.26 6.539 4.407 9.74H4.5c.8 0 1.503.418 1.902 1.048l1.813-3.134h-.012A2.249 2.249 0 0 1 6.26 6.54zm3.88.013h3.934l.82-.793c.184-.183.166-.49-.017-.674l-.814-.783h-3.897c.183.325.287.701.287 1.101 0 .42-.112.813-.312 1.149z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "M18.047 18.586a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0zM21.75 12a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "m17.598 13.202-1.813 3.134h.012a2.25 2.25 0 0 1 1.943 1.114l1.852-3.202-.092.002c-.8 0-1.503-.418-1.902-1.048zm-3.764 6.485a2.24 2.24 0 0 1-.287-1.102c0-.419.115-.812.314-1.148H9.926l-.813.79a.46.46 0 0 0 0 .657l.824.803h3.897z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2E2E2E",
    d: "M9.138 18.889a.469.469 0 0 1 0-.663l2.05-2.05a.469.469 0 0 0-.33-.801H9.194a.938.938 0 0 0-.663.275l-2.244 2.244a.937.937 0 0 0 0 1.326l2.244 2.244a.938.938 0 0 0 .663.275h1.662a.469.469 0 0 0 .332-.8l-2.05-2.05zM14.861 5.1a.469.469 0 0 1 0 .663l-2.05 2.05a.469.469 0 0 0 .332.801h1.662a.938.938 0 0 0 .662-.275l2.245-2.244a.937.937 0 0 0 0-1.326l-2.245-2.244a.938.938 0 0 0-.662-.275h-1.662a.469.469 0 0 0-.332.8l2.05 2.05z"
  }));
};
Icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#RPAProcessTemplateAsset',
    assetType: 'RPAProcessTemplate'
  },
  owner: {
    gusTeam: 'MS RPA Platform APIs',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00EE00000C2bkYYAR/view'
  },
  name: 'RPA Process Template',
  pluralName: 'RPA Process Templates',
  featureFlag: 'rpa-templates-enabled',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['rpa-process-template']
    }],
    files: [{
      id: 'rpa-process-template-binary',
      classifier: 'rpa-process-template',
      packaging: 'crpa',
      mainFileLocationProperty: 'mainFile'
    }],
    minimumInputSets: [{
      files: ['rpa-process-template-binary']
    }]
  },
  portal: {
    icon: Icon,
    color: '#0176d3',
    files: [{
      fileId: 'rpa-process-template-binary',
      label: 'RPA Process Template'
    }]
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map